require("!!/home/runner/work/Core/Core/web/reviewportal/node_modules/script-loader/addScript.js")(require("!!/home/runner/work/Core/Core/web/reviewportal/node_modules/raw-loader/index.js!/home/runner/work/Core/Core/web/reviewportal/node_modules/tether/dist/js/tether.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/tether/dist/js/tether.min.js
// module id = 586
// module chunks = 2